import React from 'react';
import { Layout } from '../components/Layout';
export function Volunteer() {
  return <Layout data-id="element-506">
      <div className="max-w-7xl mx-auto px-6 py-16" data-id="element-507">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-508">
          <h1 className="text-5xl font-bold text-black mb-4" data-id="element-509">
            Volunteer With Us
          </h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-510">
            Be Part of Something Bigger
          </p>
        </div>
        {/* Content Section */}
        <div className="max-w-4xl mx-auto mb-12" data-id="element-511">
          <div className="bg-gradient-to-br from-voices-cream to-white rounded-2xl p-8 md:p-12 border-l-8 border-voices-red mb-8" data-id="element-512">
            <h2 className="text-3xl font-bold text-black mb-6" data-id="element-513">
              Why Volunteer?
            </h2>
            <div className="space-y-4 text-lg text-gray-700 leading-relaxed" data-id="element-514">
              <p data-id="element-515">
                At Voices with Victoria, we believe that transformation happens
                when passionate people come together with a shared purpose.
                Whether you're looking to grow your skills, expand your network,
                or simply give back, volunteering with us offers a unique
                opportunity to be part of a movement that's shaping Africa's
                next generation of changemakers.
              </p>
              <p data-id="element-516">
                As a volunteer, you'll work alongside a dynamic team to create
                meaningful experiences, amplify powerful stories, and build a
                community rooted in faith, clarity, and purpose.
              </p>
            </div>
          </div>
          {/* What You'll Do */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8" data-id="element-517">
            <h3 className="text-2xl font-bold text-black mb-6" data-id="element-518">
              What You'll Do
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-519">
              {[{
              icon: '🎯',
              title: 'Event Support',
              description: 'Help coordinate and execute live events'
            }, {
              icon: '📱',
              title: 'Social Media',
              description: 'Amplify our message across digital platforms'
            }, {
              icon: '🎨',
              title: 'Creative Design',
              description: 'Create visual content and graphics'
            }, {
              icon: '✍️',
              title: 'Content Creation',
              description: 'Write blog posts and stories'
            }, {
              icon: '🎥',
              title: 'Media Production',
              description: 'Support podcast and video production'
            }, {
              icon: '🤝',
              title: 'Community Building',
              description: 'Engage with our growing community'
            }].map((item, index) => <div key={index} className="flex items-start gap-4 p-4 bg-voices-cream rounded-lg" data-id="element-520">
                  <div className="text-3xl" data-id="element-521">{item.icon}</div>
                  <div data-id="element-522">
                    <h4 className="font-bold text-black mb-1" data-id="element-523">{item.title}</h4>
                    <p className="text-gray-700 text-sm" data-id="element-524">{item.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
          {/* What You'll Gain */}
          <div className="bg-gradient-to-br from-voices-red to-red-700 text-white rounded-xl p-8 mb-8" data-id="element-525">
            <h3 className="text-2xl font-bold mb-6" data-id="element-526">What You'll Gain</h3>
            <ul className="space-y-3 text-lg" data-id="element-527">
              <li className="flex items-start gap-3" data-id="element-528">
                <span className="text-voices-gold" data-id="element-529">✓</span>
                <span data-id="element-530">
                  Hands-on experience in event management, media production, and
                  community building
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-531">
                <span className="text-voices-gold" data-id="element-532">✓</span>
                <span data-id="element-533">
                  Networking opportunities with thought leaders and changemakers
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-534">
                <span className="text-voices-gold" data-id="element-535">✓</span>
                <span data-id="element-536">Skill development and mentorship</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-537">
                <span className="text-voices-gold" data-id="element-538">✓</span>
                <span data-id="element-539">
                  A certificate of participation and reference letter upon
                  completion
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-540">
                <span className="text-voices-gold" data-id="element-541">✓</span>
                <span data-id="element-542">
                  The chance to be part of a faith-forward movement making real
                  impact
                </span>
              </li>
            </ul>
          </div>
        </div>
        {/* Form Section */}
        <div className="max-w-4xl mx-auto" data-id="element-543">
          <div className="bg-white rounded-xl shadow-2xl overflow-hidden border-t-8 border-voices-gold" data-id="element-544">
            <div className="bg-gradient-to-r from-voices-navy to-gray-800 text-white p-6 text-center" data-id="element-545">
              <h2 className="text-3xl font-bold mb-2" data-id="element-546">Ready to Join Us?</h2>
              <p className="text-lg" data-id="element-547">Fill out the form below to get started</p>
            </div>
            <div className="p-4" data-id="element-548">
              <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc3VHpdrmMTKypxIioLvpKq6H_UugehZKc_LK5eTcfKUBYu9A/viewform?usp=pp_url&embedded=true&usp=embed_googleplus" width="100%" height="1200" frameBorder="0" marginHeight={0} marginWidth={0} className="w-full" data-id="element-549">
                Loading…
              </iframe>
            </div>
          </div>
        </div>
        {/* Bottom CTA */}
        <div className="mt-12 text-center max-w-3xl mx-auto" data-id="element-550">
          <p className="text-lg text-gray-700" data-id="element-551">
            Have questions about volunteering?{' '}
            <a href="mailto:hello@voiceswithvictoria.com" className="text-voices-red font-semibold hover:text-red-700" data-id="element-552">
              Contact us
            </a>{' '}
            and we'll be happy to help!
          </p>
        </div>
      </div>
    </Layout>;
}